<template>
  <v-layout row wrap style="padding: 0 16px; margin-top: 1px;">
    <v-flex class="document-wrapper" xs12 v-if="changeOrders.length > 0">
      <v-simple-table>
        <thead>
          <tr>
            <th class="text-left document-id-header">Id</th>
            <th class="text-left document-status-header">Status</th>
            <th class="text-left document-file-header">File</th>
            <th class="text-right document-action-header">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr xs12 v-for="(changeOrder, index) in changeOrders" :key="index">
            <td class="document-id-cell">
              {{ changeOrder.id }}
            </td>
            <td class="document-status-cell">
              {{ changeOrder.status }}
            </td>
            <td class="document-file-cell">
              <div v-if="changeOrder.lastDoc != null">
                {{changeOrder.lastDoc.fileName}}
              </div>
              <div v-else>
                 No Document for this status
              </div>
            </td>
            <td class="text-right document-action-cell">
              <v-btn small icon @click="downloadDoc(changeOrder.lastDoc)">
                <v-icon color="accent">visibility</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-flex>
    <v-flex v-else>
      No Change Requests
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'ChangeOrderList',
  methods: {
    ...mapActions({
      getFile: 'changeOrderDocument/getFile'
    }),
    async downloadDoc (doc) {
      if (doc != null) {
        await this.getFile(doc)
      }
    }
  },
  computed: {
    ...mapGetters({
      changeOrders: 'changeOrder/changeOrdersByTask'
    })
  }
}
</script>
<style scoped>
  .document-wrapper {
    padding-top: 0 !important;
  }
  @media only screen and (max-width: 500px) {
    .document-id-cell,
    .document-id-header {
      padding: 0;
    }
    .document-file-cell,
    .document-status-cell,
    .document-file-header,
    .document-status-header {
      padding-left: 12px;
    }
    .document-action-cell,
    .document-action-header {
      padding: 0;
    }
  }
</style>
